<template>
  <div class="login">
    <div class="login__zw"></div>
    <img
      class="login__title"
      src="../../assets/images/login_title1.png"
      alt=""
    />
    <img
      class="login__title2"
      src="../../assets/images/login_title2.png"
      alt=""
    />
    <img
      class="login__btn"
      @click="showLoginPop = true"
      src="../../assets/images/login_btn.png"
      alt=""
    />
  </div>

  <!-- 登录 弹窗 -->
  <van-popup
    v-model:show="showLoginPop"
    style="background: none; transform: translateY(-60%)"
    :close-on-click-overlay="true"
    position="center"
    teleport="body"
  >
    <div class="loginPop">
      <div class="logclose" @click="showLoginPop = false">
        <img
          class="loginPop__close"
          @click="showLoginPop = false"
          src="../../assets/images/close.png"
          alt=""
        />
      </div>

      <div class="loginPop__form">
        <div class="loginPop__form__zw"></div>
        <div class="loginPop__form__phone">
          <input
            type="tel"
            v-model="phone"
            maxlength="11"
            class="loginPop__form__phone__input"
            placeholder="请输入您的手机号码"
          />
        </div>

        <div class="loginPop__form__code">
          <div class="loginPop__form__code__left">
            <input
              type="tel"
              v-model="code"
              maxlength="4"
              class="loginPop__form__code__left__input"
              placeholder="请输入验证码"
            />
          </div>
          <div
            v-if="disabled === false"
            class="loginPop__form__code__right"
            @click="sendCode"
          >
            <span>{{ textContent.zhText }}</span>
          </div>
          <div v-if="disabled === true" class="loginPop__form__code__right2">
            <span>{{ textContent.newText }}</span>
          </div>
        </div>

        <img
          class="loginPop__form__btn"
          :class="{ 'loginPop__form__btn--disabled': submitDisable }"
          @click="submit"
          src="../../assets/images/login_btn.png"
          alt=""
        />
        <!-- <div class="loginPop__form__code" style="color: #0068a1">
          手机号是您参与答题、接听获奖电话的唯一方式。请务必准确填写并仔细核对。
        </div> -->
        <div class="loginPop__form__zw"></div>
      </div>
    </div>
  </van-popup>
</template>
<script setup>
import { ref, reactive } from "vue";
import { showToast } from "vant";
import { useRouter } from "vue-router";
import api from "../../api";
const router = useRouter();
const showLoginPop = ref(false);
const phone = ref("");
const code = ref("");
const textContent = reactive({
  zhText: "获取验证码",
  newText: ""
});
const disabled = ref(false);
const currentTime = ref(60);
const submitDisable = ref(false);
// 倒计时
const countDown = (time) => {
  const times = setTimeout(() => {
    countDown(time);
  }, 1000);
  if (currentTime.value <= 0) {
    clearTimeout(times);
    textContent.newText = "";
    textContent.zhText = "重新发送";
    currentTime.value = 60;
    disabled.value = false;
  } else {
    disabled.value = true;
    textContent.zhText = "";
    textContent.newText = "已发送(" + currentTime.value + "秒)";
    currentTime.value = currentTime.value - 1;
  }
};
// 发送验证码
const sendCode = async () => {
  if (phone.value === "") {
    showToast({
      message: "请填写手机号码",
      forbidClick: true
    });
  } else if (!/^1[3456789]\d{9}$/.test(phone.value)) {
    showToast({
      message: "请填写正确的手机号码",
      forbidClick: true
    });
  } else {
    countDown(currentTime);
    sendCodeApi();
  }
};
const sendCodeApi = async () => {
  try {
    const result = await api.sendCode({ phone: phone.value });
    if (result) {
      //
    }
  } catch (error) {
    console.log(error + "error");
  }
};
const submit = () => {
  submitDisable.value = true;
  if (phone.value === "") {
    submitDisable.value = false;
    showToast({
      message: "请填写手机号码",
      forbidClick: true
    });
  } else if (!/^1[3456789]\d{9}$/.test(phone.value)) {
    submitDisable.value = false;
    showToast({
      message: "请填写正确的手机号码",
      forbidClick: true
    });
  } else if (code.value === "") {
    submitDisable.value = false;
    showToast({
      message: "请填写验证码",
      forbidClick: true
    });
  } else {
    login();
  }
  // loginUser()
};
const login = async () => {
  try {
    const result = await api.login({ phone: phone.value, code: code.value });
    if (result) {
      submitDisable.value = false;
      localStorage.loginTypeQa20240822 = "login";
      localStorage.tokenQa20240822 = result.token;
      router.push({ name: "StartPc" });
    }
  } catch (error) {
    submitDisable.value = false;
    console.log(error + "error");
  }
};
</script>
<style>
.van-toast {
  min-height: 2rem;
  padding: 0.2rem;
  font-size: 1.188rem;
  line-height: 2rem;
}
.van-toast--text,
.van-toast--html {
  min-width: 8rem;
  min-height: 0;
  font-size: 1.188rem;
  padding: 2rem;
}
</style>
<style lang="scss" scoped>
.login {
  width: 24.75rem;
  height: 55.078rem;
  background-image: url("../../assets/images/login_bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  &__zw {
    width: 100%;
    height: 11.22rem;
  }
  &__title {
    width: 20.13rem;
  }
  &__title2 {
    width: 21.879rem;
    height: auto;
    margin: 0;
    padding: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2.64rem;
  }
  &__btn {
    width: 18.15rem;
    height: auto;
    margin: 0;
    padding: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2.64rem;
    margin-bottom: 6.6rem;
    cursor: pointer;
  }
}
.loginPop {
  width: 22.308rem;
  position: relative;
  .logclose {
    width: 100%;
  }
  &__close {
    width: 1.914rem;
    height: auto;
    display: block;
    margin: 0;
    padding: 0;
    margin-left: auto;
    margin-right: auto;
  }
  &__form {
    width: 22.308rem;
    background: #ffffff;
    border-radius: 0.33rem;
    margin-top: 1.32rem;
    &__zw {
      width: 100%;
      height: 1.98rem;
    }
    &__phone {
      width: 19.602rem;
      height: 2.838rem;
      background: #f1f1f1;
      border-radius: 0.132rem;
      margin-left: auto;
      margin-right: auto;
      &__input {
        width: 17.688rem;
        height: 2.838rem;
        font-size: 0.792rem;
        color: #333333;
        padding: 0;
        margin: 0;
        text-align: left;
        border: none;
        outline: none;
        background-color: transparent;
        margin-left: 0.924rem;
        margin-right: auto;
      }
    }
    &__code {
      width: 19.602rem;
      height: 2.838rem;
      display: flex;
      align-items: center;
      margin-top: 0.924rem;
      margin-left: auto;
      margin-right: auto;
      &__left {
        width: 12.804rem;
        height: 2.838rem;
        background: #f1f1f1;
        border-radius: 0.132rem;
        margin-left: 0;
        margin-right: auto;
        &__input {
          width: 11.088rem;
          height: 2.838rem;
          font-size: 0.792rem;
          color: #333333;
          padding: 0;
          margin: 0;
          text-align: left;
          border: none;
          outline: none;
          background-color: transparent;
          margin-left: 0.924rem;
          margin-right: auto;
        }
      }
      &__right {
        width: 5.61rem;
        height: 2.838rem;
        background: linear-gradient(0deg, #17ac03, #0cc303);
        box-shadow: 0 0.132rem 0.462rem 0 rgba(23, 69, 5, 0.5);
        border-radius: 0.132rem;
        font-size: 0.792rem;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0;
        margin-left: auto;
      }
      &__right2 {
        width: 5.61rem;
        height: 2.838rem;
        background: linear-gradient(0deg, #9a9a9a, #b8b8b8);
        box-shadow: 0 0.132rem 0.462rem 0 rgba(90, 90, 90, 0.5);
        border-radius: 0.132rem;
        font-size: 0.792rem;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0;
        margin-left: auto;
      }
    }
    &__btn {
      width: 19.536rem;
      height: auto;
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-top: 1.716rem;
      cursor: pointer;
      &--disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
}
</style>
